import { NavigationIconButton } from 'app/components/buttons';
import { ArrowBackIcon } from 'app/components/icons';
import React from 'react';
import './BackActionDialogContentLayout.less';
import clsx from 'clsx';

export interface Props {
  children: React.ReactNode;
  className?: string;
  isLoading?: boolean;
  backIcon?: React.FC<React.SVGProps<SVGSVGElement>>;
  backIconProps?: { className: string };
  contentProps?: { className: string };
  withShadow?: boolean;
  onBack: () => void;
}

export default function BackActionDialogContentLayout({
  children,
  className,
  isLoading,
  backIcon: BackIcon = ArrowBackIcon,
  backIconProps,
  contentProps,
  withShadow,
  onBack,
}: Props) {
  return (
    <div className={clsx('back-action-dialog-content-layout', className)}>
      <NavigationIconButton
        withShadow={withShadow}
        className={clsx(
          'back-action-dialog-content-layout__navigation-icon-button',
          backIconProps?.className,
        )}
        disabled={isLoading}
        onClick={onBack}
      >
        <BackIcon width={32} height={32} />
      </NavigationIconButton>

      <div
        className={clsx(
          'back-action-dialog-content-layout__content',
          contentProps?.className,
        )}
      >
        {children}
      </div>
    </div>
  );
}
